import { type RouteComponentProps } from "react-router";
import { ScreenMax } from "styles/antTheme/Variables";
import { useMediaQuery } from "usehooks-ts";

import { BdsButtonGroup, BdsRollupButton } from "@buildertrend/components";

import { useTabNavigate } from "helpers/webview/useTabNavigate";

import { routes } from "utilities/routes";

import { PurchaseOrderTabTypes } from "entity/purchaseOrder/PurchaseOrderList/PurchaseOrderList.api.types";

interface IPurchaseOrderTabProps extends RouteComponentProps {
    id: string;
    activeTab: PurchaseOrderTabTypes;
}

export const PurchaseOrderTab = (props: IPurchaseOrderTabProps) => {
    const { activeTab } = props;

    const isXsScreen = useMediaQuery(`(max-width: ${ScreenMax.xs}px)`);
    const tabNavigate = useTabNavigate();

    const handleTabChange = (newTab: PurchaseOrderTabTypes) => {
        if (newTab === PurchaseOrderTabTypes.Bill) {
            tabNavigate(routes.bill.getListLink());
        } else {
            tabNavigate(routes.purchaseOrder.getListLink());
        }
    };

    if (isXsScreen) {
        return (
            <BdsButtonGroup
                id="tabnMobileButtonGroup"
                grow
                menuTestid="tabnMobileButtonGroup"
                rollupTestid="selectableRollup"
                selectable
                reverse
                compact
                testid="tabnMobileButtonGroup"
            >
                <BdsRollupButton
                    id="purchaseOrdersMobileButton"
                    maxStage={0}
                    onClick={() => handleTabChange(PurchaseOrderTabTypes.PurchaseOrder)}
                    selected={activeTab === PurchaseOrderTabTypes.PurchaseOrder}
                    testid="purchaseOrdersMobileButton"
                    text="Purchase Orders"
                    value="purchaseOrdersMobileButton"
                />
                <BdsRollupButton
                    id="billsMobileButton"
                    maxStage={0}
                    onClick={() => handleTabChange(PurchaseOrderTabTypes.Bill)}
                    selected={activeTab === PurchaseOrderTabTypes.Bill}
                    testid="billsMobileButton"
                    text="Bills"
                    value="billsMobileButton"
                />
            </BdsButtonGroup>
        );
    }

    return (
        <BdsButtonGroup
            id="selectGroup"
            testid="selectGroup"
            compact={true}
            menuTestid="selectGroupMenu"
            rollupTestid="selectGroupRollup"
            selectable={true}
            flexAlign="start"
        >
            <BdsRollupButton
                id="purchaseOrdersSelectButton"
                testid="purchaseOrdersSelectButton"
                onClick={() => handleTabChange(PurchaseOrderTabTypes.PurchaseOrder)}
                selected={activeTab === PurchaseOrderTabTypes.PurchaseOrder}
                text="Purchase Orders"
                value="purchaseOrders"
            />
            <BdsRollupButton
                id="billsSelectButton"
                testid="billsSelectButton"
                onClick={() => handleTabChange(PurchaseOrderTabTypes.Bill)}
                selected={activeTab === PurchaseOrderTabTypes.Bill}
                text="Bills"
                value="bills"
            />
        </BdsButtonGroup>
    );
};
